import {
  Links,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
} from "@remix-run/react";

const isProduction = process.env.NODE_ENV === "production";

export default function App() {
  return (
    <html>
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <link rel="preconnect" href="https://cdn.shopify.com/" />
        <link
          rel="stylesheet"
          href="https://cdn.shopify.com/static/fonts/inter/v4/styles.css"
        />
        <Meta />
        <Links />
      </head>
      <body>
        <Outlet />
        <ScrollRestoration />
        <Scripts />
        {isProduction ? (
          <>
            <script
              id="crisp-client"
              dangerouslySetInnerHTML={{
                __html: `
          window.$crisp=[];
          window.CRISP_WEBSITE_ID="c5f550fb-d28d-47ea-ac9a-d3e3b7fd4233";
          (function(){d=document;s=d.createElement("script");s.src="https://client.crisp.chat/l.js";s.async=1;d.getElementsByTagName("head")[0].appendChild(s);})();
          if (window.shopify.config.shop) {
            $crisp.push(["set", "user:nickname", [window.shopify.config.shop]]);
          }
          `,
              }}
            />

            <script
              id="smartlook-client"
              dangerouslySetInnerHTML={{
                __html: `window.smartlook||(function(d) {
    var o=smartlook=function(){ o.api.push(arguments)},h=d.getElementsByTagName('head')[0];
    var c=d.createElement('script');o.api=new Array();c.async=true;c.type='text/javascript';
    c.charset='utf-8';c.src='https://web-sdk.smartlook.com/recorder.js';h.appendChild(c);
    })(document);
    smartlook('init', '2ea81ebf2a66b8b89dcfafb156c6a6365ad6f1a6', { region: 'eu' });`,
              }}
            />
          </>
        ) : null}
      </body>
    </html>
  );
}
